/* eslint-disable import/no-cycle */

'use-strict';

import angular, { IHttpService } from 'angular';
import { ApiService } from '../../src/app/shared/services/api';
import { UserLoginStatistics } from '../../src/app/@shared-types/admin/statistics';
import {
  EFileSection,
  EStaticFileType,
  File,
  StaticFile,
} from '../../src/app/@shared-types/misc/file';
import { LoginCredentials, LoginResult } from '../../src/app/@types/login';

export class AuthAPIService {
  private apiService: ApiService;

  private $http: IHttpService;

  constructor(
    apiService: ApiService,
    $http: IHttpService,
  ) {
    'ngInject';

    this.apiService = apiService;
    this.$http = $http;
  }

  public loginUser = async (
    credentials: LoginCredentials,
    statistics: UserLoginStatistics,
  ): Promise<LoginResult> => {
    const res = await this.$http.post(
      `${API_URL}/api/login/login-user`,
      {
        ...credentials,
        statistics,
      },
      { withCredentials: true },
    );
    return Promise.resolve(res.data as LoginResult);
  };

  /** If `overwriteToken` is provided the token in cookies will be ignored by the server. */
  public getRefreshToken = async (
    userId: number,
    tenantId: string,
    statistics: UserLoginStatistics,
    overwriteToken?: string,
  ): Promise<LoginResult> => {
    const res = await this.$http.post(
      `${API_URL}/api/login/refresh-token`,
      {
        userId,
        tenantId,
        statistics,
        overwriteToken,
      },
      { withCredentials: true },
    );
    return Promise.resolve(res.data as LoginResult);
  };

  public getByContext = (
    section: EFileSection,
    identifier: string,
  ): Promise<File[]> => this.apiService.get<File[]>(`/api/files/${section}/${identifier}`);

  public deleteFile = (
    fileId: number,
  ): Promise<void> => this.apiService.delete<void>(`/api/files/file/${fileId}`);

  public deleteStatic = (
    staticId: string,
  ): Promise<void> => this.apiService.delete<void>(`/api/files/static/${staticId}`);

  public staticsByIdentifierAndType = (
    identifier: string,
    type: EStaticFileType,
  ): Promise<StaticFile[]> => this.apiService.get<StaticFile[]>(`/api/files/static/${type}/${identifier}`);
}

export default angular.module('services.authApiService', [])
  .service('authApiService', AuthAPIService)
  .name;
